<template>
    <!-- 云环境管理的私有网络组件(所有云环境) -->
    <div class="layout-rctable-container vpc-container"
         style="background: #fff;">
        <Helpinfo :helpData="helpData"
                  v-if="noChange"></Helpinfo>
        <envSelect @envId="envClick"></envSelect>
        <div class="table-container"
             v-if="noChange"
             style="padding:15px;margin-top:-17px;background: #fff;">
            <input ref="copyrelay"
                   v-model="copyId"
                   class="copy-el" />
            <rc-table ref="tableInstanceType"
                      :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o-2"></i>
                </Button>
                <Button type="primary"
                        @click="addVpcFun"
                        :disabled="!hasPermission('CB090108')"
                        v-if="!isProwervc && ownFlag"
                        slot="tootipL">
                    <i class="icon-plus-o-1"></i><span>{{$t('创建')}}</span>
                </Button>
                <Button @click="exportFun()"
                        :disabled="!hasPermission('CB090112')"
                        slot="tootipL">
                    <i class="icon-export-1-o"></i>
                    {{$t('导出')}}</Button>
                <!-- <div slot="footerL">
                    {{$t('平台将定时同步上述信息，您可以手动点击')}}
                    <span @click="sync"
                          class="synchronous">{{$t('同步')}}</span>
                    {{$t('立即进行更新')}}
                </div> -->
            </rc-table>
        </div>
        <div v-if="loading"
             style="height: 100%">
            <Spin fix><span>{{$t('导出中')}}...</span></Spin>
        </div>
        <editinfomodal ref="editinfomodal"
                       @refresh="refresh"
                       :detail="editRow"></editinfomodal>
        <bind-tags ref="bindTags"
                   @refresh="refresh" />
    </div>
</template>
<script>
import Helpinfo from '@/views/components/basic/helpinfo.vue'
import rcTable from '@c/basic/rcTable'
import poptip1 from '@/views/components/basic/poptip/poptip.vue'
import bindTags from '@/views/components/basic/tags/bindTags.vue'
import API from '@/service/api.js'
import editinfomodal from '@/views/console/vpc/components/editinfomodal.vue'
import envSelect from '@c/basic/env'
export default {
    name: 'envvpc',
    components: {
        Helpinfo,
        rcTable,
        bindTags,
        editinfomodal,
        envSelect
    },
    data: function () {
        return {
            helpData: {
                type: '',
                modelName: this.$t('私有网络')
            },
            copyId: null,
            objType: 'vpc',
            noChange: true,
            isProwervc: false,
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_ENV_VPC, false),
                    params: {
                        projectId: this.$store.state.user.currentUser.projectId === 'all' ? '' : this.$store.state.user.currentUser.projectId,
                        cloudEnvId: sessionStorage.getItem('resourcesEnvId') || null
                    }
                },

                searchColumns: [
                    {
                        key: 'nameLike',
                        title: this.$t('名称'),
                        searchDefaultValue: ''
                    }
                ],
                referenceVal: 1325,
                isWebsoct: true,
                wsKey: 'id',
                searchShow: true,
                tableSearchKey: '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: '',
                isMultiSelect: false,
                columnsChooseShow: true,
                columns: [
                    {
                        title: this.$t('名称') + '/ID',
                        key: 'name',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 200,
                        render: (h, params) => {
                            let isOpclick = true
                            if (['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS'].includes(params.row.cloudEnvType) && !params.row.owner && params.row.totalSubnetNum === 0) {
                                isOpclick = false
                            }
                            const status = params.row.status === 'CREATE_FAILURE' || params.row.status === 'CREATING'
                            return h('div', {
                                class: 'ellipsis  resource',
                                style: { position: 'relative' }
                            }, [
                                h(
                                    'div',
                                    {
                                        class: 'ellipsis',
                                        style: { width: '170px', paddingTop: '5px', height: '50px' }
                                    },
                                    [
                                        h((status || !isOpclick) ? 'p' : 'a', {
                                            class: {
                                                readonly: !this.hasPermission('CB090101')
                                            },
                                            style: status || !isOpclick ? 'color: #c5c8ce;cursor: not-allowed;' : '',
                                            attrs: { title: params.row.name },
                                            on: { click: () => this.hasPermission('CB090101') && !status && isOpclick && this.manageFun(params.row) }
                                        }, params.row.name),
                                        h(
                                            'div',
                                            {
                                                class: 'ellipsis',
                                                style: { width: '170px', color: '#666', paddingBottom: '5px' },
                                                attrs: {
                                                    title: params.row.uuid || '--'
                                                }
                                            },
                                            params.row.uuid || '--'
                                        ),
                                        h(
                                            'Tooltip',
                                            {
                                                class: 'rc-tips copyId',
                                                style: { position: 'absolute', left: '175px', top: '22px', width: '15px' },
                                                props: {
                                                    transfer: true,
                                                    placement: 'top',
                                                    theme: 'light',
                                                    content: this.$t('复制ID')
                                                }
                                            },
                                            [
                                                h('Icon', {
                                                    class: 'copy-icon',
                                                    style: { color: '#1f68b3', 'font-size': '14px' },
                                                    props: {
                                                        type: 'ios-browsers-outline'
                                                    },
                                                    on: {
                                                        click: () =>
                                                            this.copylink(
                                                                params.row.uuid
                                                            )
                                                    }
                                                })
                                            ]
                                        )
                                    ]
                                )
                            ])
                        }
                    },
                    {
                        title: this.$t('云环境'),
                        key: 'cloudEnvType',
                        sortable: true,
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 200,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.cloudEnvName }, class: { 'rc-ellipsis': true } }, [
                                h('i', { class: this.envIcon(params.row.cloudEnvType), style: 'margin-right: 0' }),
                                h('span', { class: 'icon-text' }, !params.row.cloudEnvName ? this.$t('其他') : params.row.cloudEnvName)
                            ])
                        }
                    },
                    {
                        title: this.$t('网段'),
                        key: 'cidr',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 170,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.cidr } }, params.row.cidr)
                        }
                    },
                    {
                        title: this.$i18n.t('状态'),
                        key: 'status',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        render: (h, params) => {
                            let state = ''
                            let component = 'statusview'
                            if (params.row.status === 'ACTIVE') {
                                state = this.$t('运行中')
                            } else if (params.row.status === 'INACTIVE') {
                                state = this.$t('不可用')
                            } else if (params.row.status === 'CREATING') {
                                state = this.$t('创建中')
                            } else if (params.row.status === 'DELETING') {
                                state = this.$t('删除中')
                            } else if (params.row.status === 'CREATE_FAILURE') {
                                state = this.$t('创建失败')
                                component = 'syncpoptip'
                            }
                            return h(component, {
                                props: params.row.status === 'CREATE_FAILURE' ? {
                                    value: '创建失败',
                                    params: {
                                        resType: 'network',
                                        resSid: params.row.id
                                    }
                                }
                                    : {
                                        state: params.row.status.toLowerCase(),
                                        stateName: state
                                    }
                            })
                        }
                    },
                    {
                        title: this.$t('子网'),
                        key: 'totalSubnetNum',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 80,
                        render: (h, params) => {
                            // openstack、escloud 租户下显示public为可读，名称、个数、管理变灰，都不能进行点击，个数显示空
                            // （ 当网络属于外部网络且数量为0个时，才不能点击名称、管理、不显示个数）
                            let isOpclick = true
                            if (['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS'].includes(params.row.cloudEnvType) && !params.row.owner && params.row.totalSubnetNum === 0) {
                                isOpclick = false
                            }
                            const status = params.row.status === 'CREATE_FAILURE' || params.row.status === 'CREATING'
                            return h('a', { class: { readonly: !this.hasPermission('CB090101') }, style: status || !isOpclick || params.row.totalSubnetNum === 0 ? 'display: none;' : '', on: { click: () => this.hasPermission('CB090101') && this.gotoSubnet(params.row) } }, params.row.totalSubnetNum + '个')
                        }
                    },
                    {
                        title: this.$t('云主机数量'),
                        key: 'vpcDeviceNum',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        supportEnvs: ['HuaweiCloud', 'HCSO', 'FusionCompute'],
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.vpcDeviceNum } }, params.row.vpcDeviceNum)
                        }
                    },
                    {
                        title: this.$t('标签'),
                        // key: 'tagNamesLike',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: false,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        searchData: [],
                        searchFilterValues: ['all'], // 只适用于下拉搜索，当有searchFilterValues时，会过滤数组里面的搜索值
                        render: (h, params) => {
                            const tags = []
                            const colors = params.row.rgbCodes && params.row.rgbCodes.split(',')
                            const tagValues = params.row.tagValues && params.row.tagValues.split(',')
                            params.row.tagNames && params.row.tagNames.split(',').forEach((r, i) => {
                                const obj = { tagName: r, tagValue: tagValues ? tagValues[i] : '', rgbCode: colors[i] }
                                tags.push(obj)
                            })
                            return h('div', [
                                h(poptip1,
                                    {
                                        props: {
                                            values: {
                                                id: params.row.id,
                                                childs: tags
                                            }
                                        },
                                        on: {
                                            showBindWindow: () => {
                                                this.showBindWindow(params.row.id, tags)
                                            }
                                        }
                                    },
                                    [
                                        h('span', {
                                            class: 'ivu-icon ivu-icon-ios-pricetags-outline',
                                            style: 'fontSize:16px;color: #3498dc;cursor:pointer;'
                                        })
                                    ])
                            ])
                        }
                    },
                    {
                        title: this.$t('网络出口'),
                        key: 'networkExport',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        supportEnvs: ['CloudOS', 'CloudOS-Admin'],
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.networkExport } }, params.row.networkExport)
                        }
                    },
                    {
                        title: this.$t('资源区域'),
                        key: 'resZonesName',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        supportEnvs: ['CloudOS', 'CloudOS-Admin'],
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.resZonesName } }, params.row.resZonesName)
                        }
                    },
                    {
                        title: this.$i18n.t('路由表'),
                        key: 'routeTableNum',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        supportEnvs: ['Aliyun'],
                        render: (h, params) => {
                            return h('div', {
                                class: 'rc-custom-tag'
                            }, [
                                h('span', params.row.routeTableNum ? params.row.routeTableNum : 0)
                            ])
                        }
                    },
                    {
                        title: this.$i18n.t('所属项目'),
                        key: 'originOrgName',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.originOrgName } }, params.row.originOrgName)
                        }
                    },
                    {
                        title: this.$t('异常信息'),
                        key: 'statusInfo',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: false,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        excludeEnvs: ['Qcloud'],
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.statusInfo } }, params.row.statusInfo)
                        }
                    },
                    {
                        title: this.$t('描述'),
                        key: 'description',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.description } }, params.row.description)
                        }
                    },
                    {
                        title: this.$t('是否共享'),
                        key: 'shared',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: false,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        excludeEnvs: ['Qcloud', 'Aws', 'PowerVC', 'VMware', 'FusionCompute', 'OpenStack', 'OpenStack-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'Nine9Cloud', 'Nine9Cloud-Admin'],
                        render: (h, params) => {
                            return h('span', params.row.shared ? this.$t('是') : this.$t('否'))
                        }
                    },
                    {
                        title: this.$t('是否外网'),
                        key: 'external',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: false,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        excludeEnvs: ['VMware', 'FusionCompute', 'OpenStack', 'OpenStack-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'Nine9Cloud', 'Nine9Cloud-Admin', 'HuaweiCloud', 'HCSO'],
                        render: (h, params) => {
                            return h('span', params.row.external ? this.$t('是') : this.$t('否'))
                        }
                    },
                    {
                        title: this.$t('共享'),
                        key: 'shared',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        supportEnvs: ['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS'],
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.shared ? this.$t('是') : this.$t('否') } }, params.row.shared ? this.$t('是') : this.$t('否'))
                        }
                    },
                    {
                        title: this.$t('外部网络'),
                        key: 'external',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 120,
                        supportEnvs: ['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS'],
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.external === 'true' ? this.$t('是') : this.$t('否') } }, params.row.external === 'true' ? this.$t('是') : this.$t('否'))
                        }
                    },
                    {
                        title: this.$t('操作'),
                        width: 150,
                        fixed: 'right',
                        // excludeEnvs: ['Azure'],
                        render: (h, params) => {
                            let isOpclick = true
                            if (['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS'].includes(params.row.cloudEnvType) && !params.row.owner && params.row.totalSubnetNum === 0) {
                                isOpclick = false
                            }
                            const isOwner = ['OpenStack-Admin', 'ESCloud-Admin', 'Nine9Cloud-Admin'].includes(params.row.cloudEnvType) || params.row.owner

                            return h('div',
                                {
                                    class: 'tbl-btn-div'
                                },
                                [
                                    h('a', {
                                        class: { 'disabled-per': !this.hasPermission('CB090101') || (params.row.status === 'CREATE_FAILURE' || params.row.status === 'CREATING' || !isOpclick || !this.ownFlag) },
                                        on: { click: () => this.hasPermission('CB090101') && params.row.status !== 'CREATE_FAILURE' && params.row.status !== 'CREATING' && isOpclick && this.ownFlag && this.manageFun(params.row) }
                                    }, this.$t('管理')),
                                    h('a', {
                                        class: { 'disabled-per': !this.hasPermission('CB090102') || (params.row.status === 'CREATE_FAILURE' || params.row.status === 'CREATING' || params.row.alloc || !isOwner || !this.ownFlag) },
                                        on: { click: () => this.hasPermission('CB090102') && params.row.status !== 'CREATE_FAILURE' && params.row.status !== 'CREATING' && !params.row.alloc && isOwner && this.ownFlag && params.row.mode !== 'share' && this.editFun(params.row) }
                                    }, this.$t('编辑')),
                                    h('a', {
                                        class: { 'disabled-per': !this.hasPermission('CB090103') || (params.row.status === 'DELETING' || params.row.alloc || !isOwner || !this.ownFlag) },
                                        on: { click: () => this.hasPermission('CB090103') && params.row.status !== 'DELETING' && !params.row.alloc && isOwner && this.ownFlag && params.row.mode !== 'share' && this.deleteFun(params.row) }
                                    }, this.$t('删除'))
                                ]
                            )
                        }
                    }
                ]
            },
            editRow: null,
            loading: false,
            instanceWs: null,
            ownFlag: true
        }
    },
    created () {
        this.refresh()
    },
    mounted () {
        this.websoctRefesh()
    },
    beforeDestroy () {
        // 取消websocket订阅
        if (this.instanceWs) {
            this.instanceWs.unsubscribe()
            this.$store.commit('deleteWsList', '/topic/network')
        }
    },
    methods: {
        // 复制剪切板
        copylink (id) {
            this.copyId = id
            this.$nextTick(() => {
                const copyrelay = this.$refs.copyrelay
                copyrelay.select()
                document.execCommand('Copy')
                this.$Message.success(this.$t('ID复制成功'))
            })
        },
        // 云环境查询
        envClick (data) {
            this.tableAttr.source.params.cloudEnvId = data
            this.$refs.tableInstanceType && this.$refs.tableInstanceType.refreshTable()
        },
        showBindWindow (id, tags) {
            this.$refs.bindTags.open(id, tags, this.objType)
        },
        fetchDate () {
            this.noChange = false
            this.refresh()
            this.$nextTick(() => {
                this.noChange = true
            })
        },
        refresh () {
            this.tableAttr.source.params = {
                cloudEnvId: sessionStorage.getItem('resourcesEnvId') || null
            }
            // 查询保持
            if (this.$route.query.vpcName) {
                this.tableAttr.searchDefaultValueList.push({
                    key: 'nameLike',
                    name: this.$route.query.vpcName,
                    title: this.$t('名称'),
                    value: this.$route.query.vpcName
                })
            }
            if (sessionStorage.ts_list && JSON.parse(sessionStorage.ts_list)[this.tableAttr.tableSearchKey]) {
                this.tableAttr.searchDefaultValueList = JSON.parse(sessionStorage.ts_list)[this.tableAttr.tableSearchKey]
            }
            this.$refs.tableInstanceType && this.$refs.tableInstanceType.refreshTable()
        },
        // 创建
        addVpcFun () {
            this.$nextTick(() => {
                // this.$refs.createvpc.openModal()
                this.$router.push({ path: '/mgt/vpc/create', query: {} })
            })
        },
        // 跳转到子网页面
        gotoSubnet (row) {
            this.$router.push({ path: `/mgt/vpc/detail/${row.id}`, query: { envId: row.cloudEnvId, envType: row.cloudEnvType, envName: row.cloudEnvName, region: row.region, alloc: row.alloc, name: row.name, tab: 'subnet' } })
        },
        // 编辑
        editFun (obj) {
            const row = JSON.parse(JSON.stringify(obj))
            delete row._index
            delete row._rowKey
            this.editRow = row
            this.$refs.editinfomodal.openModal()
        },
        // 单个删除
        deleteFun (row) {
            // if (row.resPool) {
            //     this.$Message.info('该网络与分区:' + row.resPool + '关联，不能删除')
            //     return
            // }
            let msg = row.cloudEnvType === 'VMware' && row.resPoolName ? `您确定要删除该网络吗？删除该网络可能导致分区${row.resPoolName}无法使用` : `您确定要删除该${row.cloudEnvType === 'VMware' ? '网络' : '私有网络'}吗？`
            if (row.shareToEnvs) {
                if (row.cloudEnvType === 'VMware' && row.resPoolName) {
                    msg += `，将影响云环境${row.shareToEnvs}`
                } else {
                    msg += `，删除该网络将影响云环境${row.shareToEnvs}`
                }
            }
            this.$Modal.confirm({
                title: this.$t('删除'),
                content: msg,
                onOk: () => {
                    this.axios.delete(this.urlFormat(`${API.GET_ENV_VPC}/${row.id}`, false)).then(res => {
                        if (res.status) {
                            this.refresh()
                        }
                    })
                }
            })
        },
        // 点击管理
        manageFun (row) {
            this.$router.push({ path: `/mgt/vpc/detail/${row.id}`, query: { envId: row.cloudEnvId, envType: row.cloudEnvType, envName: row.cloudEnvName, region: row.region, alloc: row.alloc, name: row.name } })
        },
        // 导出
        exportFun () {
            this.loading = true
            // 查询条件
            let params = ''
            if (sessionStorage.getItem('resourcesEnvId')) {
                params += '?cloudEnvId=' + sessionStorage.getItem('resourcesEnvId')
            }
            if (this.$refs.tableInstanceType.searchValueList && this.$refs.tableInstanceType.searchValueList.length > 0) {
                params += (sessionStorage.getItem('resourcesEnvId') ? '&' : '?') + (this.$refs.tableInstanceType.searchValueList[0].key + '=' + this.$refs.tableInstanceType.searchValueList[0].value)
            }
            const [userSid] = [this.$store.state.user.currentUser.info.userSid, '', '']
            this.axios({
                method: 'get',
                url: this.urlFormat(API.RES_EXPORT + '/networks' + params, false),
                headers: {
                    token: userSid
                },
                responseType: 'blob'
            }).then(res => {
                if (res) {
                    // 文件下载
                    // const blob = new Blob([res], {
                    //     type: 'application/vnd.ms-excel'
                    // })
                    // let link = document.createElement('a')
                    // link.href = URL.createObjectURL(blob)
                    // link.setAttribute('download', '私有网络文件.xlsx')
                    // link.click()
                    // link = null
                    this.$Message.success(this.$t('导出成功'))
                    this.loading = false
                }
            }).catch(e => {
                this.$Message.error(this.$t('导出失败'))
                this.loading = false
            })
        },
        interval (func, tLength = 5000, time = 1) {
            let t = 0
            const inter = setInterval(() => {
                if (t < time) {
                    if (func) {
                        func()
                    }
                } else {
                    clearInterval(inter)
                }
                t++
            }, tLength)
        },
        websoctRefesh () {
            let refresh = this.$refs.tableInstanceType && this.$refs.tableInstanceType.refreshTable
            this.instanceWs = this.$websocket('/topic/network', (result) => {
                refresh = this.$refs.tableInstanceType ? this.$refs.tableInstanceType.refreshTable : null
                refresh && refresh({
                    cloudEnvId: sessionStorage.getItem('resourcesEnvId') || null
                }, null, parseInt(result.body))
            })
            // 存储websocket
            this.$store.commit('addWsList', {
                url: '/topic/network',
                callback: (result) => {
                    refresh = this.$refs.tableInstanceType ? this.$refs.tableInstanceType.refreshTable : null
                    refresh && refresh({
                        cloudEnvId: sessionStorage.getItem('resourcesEnvId') || null
                    }, null, parseInt(result.body))
                }
            })
        }
    },
    watch: {
        // 如果路由有变化，会执行该方法
        '$route' (newNal, oldval) {
            this.fetchDate()
        }
    }
}
</script>
<style lang="less" scoped>
.edit-vpc {
    .form-item {
        width: 350px;
    }
}
.quick-config {
    padding-top: 0px !important;
}
.copy-el {
    opacity: 0;
    height: 1px;
    overflow: hidden;
    margin: 0;
    padding: 0;
}
.table-container {
    height: calc(~'100% - 30px');
    overflow-y: auto;
}
</style>
<style lang="less">
.vpc-container {
    height: 100%;
}
.vpc-container .ivu-spin-text {
    display: block !important;
    margin-left: -12px;
    margin-top: 5px;
}

.newRcTable .rcTable-content .ellipsis > div.copyId {
    opacity: 0;
}
.newRcTable .rcTable-content .ellipsis > div {
    .copyId {
        opacity: 0;
    }
}
.newRcTable .rcTable-content .ellipsis > div:hover {
    .copyId {
        opacity: 1;
    }
}
.newRcTable .rcTable-content .ellipsis > div {
    .name {
        line-height: 22px;
    }
    .copyId {
        line-height: 22px;
    }
}
.vpc-container .ivu-spin-text {
    display: block !important;
    margin-left: -12px;
    margin-top: 5px;
}
</style>
